<template>
  <div
    id="configuration-modal"
    class="modal"
    role="dialog"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('hide-modal')">
            &times;
          </button>
          <h4 class="modal-title text-left">
            <i class="fa fa-sliders" aria-hidden="true"></i> Configure Fabric
          </h4>
        </div>
        <div class="modal-body bg-white">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Supplier Code</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    v-model="fabric.current_fabric_supplier_code"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Width</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="fabric.default_width"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Unit Price</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    @input="
                      fabric.default_unit_price_total =
                        fabric.default_unit_price * 1 +
                        fabric.default_vat_per_unit * 1
                    "
                    v-model="fabric.default_unit_price"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Currency</label>
                <div class="col-sm-7">
                  <v-select
                    :options="['THB', 'USD']"
                    v-model="fabric.default_currency"
                    placeholder="Choose Currency"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Vat</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control"
                    @input="
                      fabric.default_unit_price_total =
                        fabric.default_unit_price * 1 +
                        fabric.default_vat_per_unit * 1
                    "
                    v-model="fabric.default_vat_per_unit"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row" v-if="!fabric.is_jersey">
                <label class="col-sm-5 col-form-label">Unit</label>
                <div class="col-sm-7">
                  <v-select
                    placeholder="Choose One"
                    v-model="fabric.default_unit"
                    :reduce="(unit) => unit.value"
                    :options="[
                      { value: 'm', label: 'Meter' },
                      { value: 'y', label: 'Yard' },
                      { value: 'kg', label: 'Kilogram' },
                    ]"
                    label="label"
                    :clearable="false"
                    class="unit"
                  />
                </div>
              </div>
              <div class="form-group row" v-if="fabric.is_jersey">
                <label class="col-sm-5 col-form-label">Unit</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabric.default_unit"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Total Unit Price</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabric.default_unit_price_total"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <br />
          <div class="form-group row" v-if="$auth.user().role === 'admin'">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Fiber 1</label
            >
            <div class="col-sm-4">
              <v-select
                :options="fieldValues.fibers"
                v-model="fabric.fiber_1"
                placeholder="Choose One"
              />
              <div v-if="showFiberError" class="fiber_error">Fiber 1 can't be empty</div>
            </div>
            <div class="col-md-4 slider-container">
              <vue-slider
                v-model="fabric.fiber_1_percentage"
                :min="0"
                :max="100"
              />
            </div>
            <div class="col-md-2">
              <input
                type="text"
                v-model="fabric.fiber_1_percentage"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row" v-if="$auth.user().role === 'admin'">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Fiber 2</label
            >
            <div class="col-sm-4">
              <v-select
                :options="fieldValues.fibers"
                v-model="fabric.fiber_2"
                placeholder="Choose One"
              />
            </div>
            <div class="col-md-4 slider-container">
              <vue-slider
                v-model="fabric.fiber_2_percentage"
                :min="0"
                :max="100"
              />
            </div>
            <div class="col-md-2">
              <input
                type="text"
                v-model="fabric.fiber_2_percentage"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row" v-if="$auth.user().role === 'admin'">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Fiber 3</label
            >
            <div class="col-sm-4">
              <v-select
                :options="fieldValues.fibers"
                v-model="fabric.fiber_3"
                placeholder="Choose One"
              />
            </div>
            <div class="col-md-4 slider-container">
              <vue-slider
                v-model="fabric.fiber_3_percentage"
                :min="0"
                :max="100"
              />
            </div>
            <div class="col-md-2">
              <input
                type="text"
                v-model="fabric.fiber_3_percentage"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Composition label</label
            >
            <div class="col-sm-6">
              <v-select
                :options="fieldValues.formattedCompositionLabels"
                v-model="fabric.fabric_composition_label_id"
                placeholder="Choose One"
                label="name"
                :reduce="(compositionLabel) => compositionLabel.id"
              />
            </div>
          </div>
          <div class="line"></div>
          <br />
          <br />
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Yarn Count</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="fabric.default_yarn_count"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Coloring Style</label>
                <div class="col-sm-7">
                  <v-select
                    :options="fieldValues.coloringStyles"
                    v-model="fabric.default_coloring_style"
                    placeholder="Choose One"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Density</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="fabric.default_density"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Finish</label>
                <div class="col-sm-7">
                  <v-select
                    :options="fieldValues.finishes"
                    v-model="fabric.default_finish"
                    placeholder="Choose One"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Stretch</label>
                <div class="col-sm-7">
                  <select
                    class="form-control"
                    v-model="fabric.is_stretch_fabric"
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Jersey</label>
                <div class="col-sm-7">
                  <select
                    class="form-control"
                    v-model="fabric.is_jersey_fabric"
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Weight</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabric.default_weight"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label"
                  >Interlining</label
                >
                <div class="col-sm-7">
                  <select
                    class="form-control"
                    v-model="fabric.interlining"
                  >
                     <option v-for="interlining in fieldValues.interlinings" :value="interlining.code">{{ interlining.code }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Certificate</label>
                <div class="col-sm-7">
                  <v-select
                    placeholder="No certificate"
                    v-model="fabric.certificate"
                    :options="fieldValues.certificates"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label"
                  >Special characteristic</label
                >
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="fabric.special_description_suffix"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer bg-white">
          <div class="row">
            <div class="col-md-12">
              <button
                class="btn btn-block btn-success"
                @click="$emit('save-modal')"
                :disabled="showFiberError"
              >
                Save Configuration
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
export default {
  props: ["fieldValues", "fabric"],
  components: {
    VueSlider,
  },
  watch: {
    "fabric.fiber_1": {
      handler(newValues, oldValues) {
        if(this.fabric.fiber_1 === null) {
          this.showFiberError = true;
        } else {
          this.showFiberError = false;
        }
      }
    },
    "fabric.default_unit_price": {
      handler(newValues, oldValues) {
        let unitPrice = parseFloat(this.fabric.default_unit_price);
        let vatPerUnit = parseFloat(this.fabric.default_vat_per_unit);
        this.fabric.default_unit_price_total = !isNaN(vatPerUnit)
          ? (
              parseFloat(this.fabric.default_unit_price) +
              parseFloat(this.fabric.default_vat_per_unit)
            ).toFixed(2)
          : parseFloat(this.fabric.default_unit_price);
      },
    },
    "fabric.default_vat_per_unit": {
      handler(newValues, oldValues) {
        let unitPrice = parseFloat(this.fabric.default_unit_price);
        let vatPerUnit = parseFloat(this.fabric.default_vat_per_unit);
        this.fabric.default_unit_price_total = !isNaN(unitPrice)
          ? (
              parseFloat(this.fabric.default_unit_price) +
              parseFloat(this.fabric.default_vat_per_unit)
            ).toFixed(2)
          : parseFloat(this.fabric.default_vat_per_unit);
      },
    },
  },
  data: function () {
    return {
      showFiberError: false
    }
  },
  mounted() {
    if(this.fabric.fiber_1 === null) {
      this.showFiberError = true;
    }
  }
};
</script>

<style scoped>
.modal-header .close {
  margin-top: -4px !important;
  font-size: 30px;
}
.fiber_error {
  color: red;
  margin-top: 7px;
}
</style>
